'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Masthead = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Masthead = require('./Masthead');

var _Masthead2 = _interopRequireDefault(_Masthead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.Masthead = _Masthead2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-masthead')(_Masthead2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/Masthead/index.js
 ** module id = 604
 ** module chunks = 1
 **/